import { render, staticRenderFns } from "./Lpb.vue?vue&type=template&id=542924a4&scoped=true"
import script from "./Lpb.vue?vue&type=script&lang=js"
export * from "./Lpb.vue?vue&type=script&lang=js"
import style0 from "./Lpb.vue?vue&type=style&index=0&id=542924a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542924a4",
  null
  
)

export default component.exports